//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ApprovalBillView',
  props: {
    formCreateInject: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};